import { useTranslation } from 'react-i18next';
import React, { FC, useState } from 'react';
import SelectForm from '../form/SelectForm';
import { roleBackOfficeList } from '../../../domain/User/Erole';

export type FoldersListFiltersValues = {
  formId: string|null
  searchQuery: string
}
export type FoldersListFiltersProps = {
  onFiltersChange: ({ formId, searchQuery }: FoldersListFiltersValues) => void
  userRole?: string | null
}

const FoldersListFilters: FC<FoldersListFiltersProps> = ({ onFiltersChange, userRole }) => {
  const { t } = useTranslation()
  const isBackOfficeUser = userRole && roleBackOfficeList.includes(userRole) || true;
  const [filters, setFilters] = useState<FoldersListFiltersValues>({
    formId: null,
    searchQuery: '',
  })

  const handleFilterChange = (filterName, filterValue) => {
    const newFilters = {
      ...filters,
      [filterName]: filterValue
    }
    setFilters(newFilters)
    onFiltersChange(newFilters)
  }

  return (
    <div className="folders-filters">
      <label>{t('folder-filters.label')}</label>
      <div className="flex-container">
        {isBackOfficeUser && (
          <div className="col-md-4">
            <SelectForm onSelectChange={(formId) => handleFilterChange('formId', formId)} />
          </div>
        )}
        <div className="col-md-8">
          <input
            type="text"
            value={filters.searchQuery}
            onChange={(e) => handleFilterChange('searchQuery', e.target.value)}
            style={{ boxShadow: `0px 5px 8px rgb(0 0 0 / 10%)`, width: '100%' }}
            placeholder={t('common.search')}
            className="button-search"
          />
        </div>
      </div>
    </div>
  )
};

export default FoldersListFilters;
